import { Button, Card, Col, Modal, Radio, RadioChangeEvent, Row, Select, Space, Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogoWidget } from "../playground/widgets";

interface LandingPageProps {

}
export function LandingPage(props: LandingPageProps) {

    const [isModalOpen, setIsModalOpen] = useState<boolean>(true);
    const [value, setValue] = useState<number>(1);
    const [selected, setSelected] = useState<string>("1")
    const [is2FAenable, set2FAEnable] = useState<boolean>(false)

    const navigate = useNavigate();

    const handleOk = () => {
        setIsModalOpen(false);

        if (value == 2 && selected === "1") {
            navigate('/playground')
        }
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onChange = (e: RadioChangeEvent) => {
        console.log('radio checked', e.target.value);
        setValue(e.target.value);
    };

    const handleChangeSelect = (value: string) => {
        console.log(`selected ${value}`);
        setSelected(value)
    };

    const showModal = () => {
        setIsModalOpen(true);
    };

    return (
        <>
            <Modal title="Basic Modal" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <Radio.Group onChange={onChange} value={value}>
                    <Space direction="vertical">
                        <Radio value={1}>Create New Project</Radio>
                        <Radio value={2}>Open Existing Project</Radio>
                    </Space>
                </Radio.Group>
                <br /><br />
                <Row>
                    {
                        (value == 2) ? <>
                            <Select
                                style={{ width: 120 }}
                                onChange={handleChangeSelect}
                                value={selected}
                                options={[
                                    { value: "1", label: 'WorkFlow Center' },
                                ]}
                            />
                        </> : <></>
                    }
                </Row>
            </Modal>

            <Row>
                <Col span={6}>

                </Col>
                <Col span={12}>
                    <Card>
                        <Row>
                            <LogoWidget />
                        </Row>
                        <Row>
                            <Typography className='loginContainer__titlebox__title iil-txt-header2 iil-txt-white'>
                                Welcome to Formatic
                            </Typography>
                        </Row>
                        <Row>
                            <Space direction="vertical">
                                <Space wrap>

                                    <Button type="primary" onClick={showModal}>
                                        Start
                                    </Button>
                                    {
                                        is2FAenable ?
                                            <Button type="primary" onClick={showModal}>
                                                Disable 2FA
                                            </Button> :
                                            <Button type="primary" onClick={showModal}>
                                                Enable 2FA
                                            </Button>
                                    }

                                </Space>
                            </Space>
                        </Row>
                    </Card>
                </Col>
                <Col span={6}>

                </Col>
            </Row>



        </>
    )
}